<template>
  <div class="layout-content-list exception-order-batch">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>发票</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>异常单处理列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tab-Location">
      <el-tabs v-model="tabActive" @tab-click="tabChange" class="control-tab">
        <el-tab-pane label="异常运单" name="list"></el-tab-pane>
        <el-tab-pane label="批量处理" name="batch"></el-tab-pane>
        <el-tab-pane label="一键处理" name="deal"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="toolbar-wrap">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">批次号</span>
        <el-input
          v-model.trim="tableOptions.batchId"
          style="width: 170px"
          :maxlength="ordernumberKeywordLimit"
          placeholder="请输入批次号"
          clearable
        ></el-input>
      </div>

      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">发布时间</span>
        <el-date-picker
          v-model="tableOptions.beginTime"
          type="date"
          style="width: 140px"
          value-format="timestamp"
          :picker-options="pickerOptions"
          :clearable="false"
          placeholder="选择开始日期"
        ></el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="tableOptions.endTime"
          type="date"
          style="width: 140px"
          value-format="timestamp"
          :picker-options="pickerOptions"
          :clearable="false"
          placeholder="选择结束日期"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item" id="auto-2">
        <span class="demonstration">批次状态</span>
        <el-select
          style="width: 140px"
          v-model="tableOptions.batchStatus"
          placeholder="请选择批次状态"
          clearable
          @change="changeStatus"
        >
          <el-option v-for="item in statusList" :label="item.label" :value="item.value" :key="item.value"> </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-3">
        <span class="demonstration">运单号</span>
        <el-input
          v-model.trim="tableOptions.orderNumber"
          style="width: 170px"
          :maxlength="ordernumberKeywordLimit"
          placeholder="请输入运单号"
          clearable
        ></el-input>
      </div>
      <div class="toolbar-item mr-20">
        <el-button class="custom-search-btn" @click="handleSearch" id="auto-4">查询</el-button>
        <el-button class="custom-reset-btn" @click="resetOption" id="auto-5">重置</el-button>
      </div>
    </div>
    <div style="height: 10px; background: #f8fafb"></div>
    <div class="table-custom-box" id="auto-6">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <template #batchId="{ scope }">
          <span class="font-green pointer" @click="showDetail(scope.row)">{{ scope.row.batchId }}</span>
        </template>
        <template #batchStatusDesc="{ scope }">
          <span :class="[scope.row.batchStatus === 0 || scope.row.batchStatus === 3 ? 'font-orange' : 'font-green']">{{
            scope.row.batchStatusDesc
          }}</span>
        </template>

        <template #handle="{ scope }">
          <el-button
            v-if="scope.row.batchStatus === 0 || scope.row.batchStatus === 3"
            type="text"
            class="font-size12 font-blue"
            @click="handleToDetail(scope.row)"
            >开始处理</el-button
          >
          <span v-else class="btn-disabled">开始处理</span>
        </template>
      </fe-table>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:6
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import tableMixin from '@/utils/tableMixin';
import api from '@/api/base.new.api';
import { WUYI, vali } from '@/api/common';
export default {
  mixins: [tableMixin],
  name: 'ExceptionOrderBatch',
  data: function () {
    return {
      columns: [
        { label: '批次号', prop: 'batchId', width: 160 },
        { label: '运单数量', prop: 'orderCount', width: 90 },
        { label: '批量异常批注', prop: 'labelName' },
        { label: '发布时间', prop: 'overTime', width: 140 },
        { label: '批次状态', prop: 'batchStatusDesc', width: 140 },
        { label: '驳回原因', prop: 'lastRejectionReason' },
        { label: '操作', prop: 'handle', width: 100 }
      ],
      axiosConfig: { url: api.abnormalBatchList }, // 列表接口
      pagination: {
        pageNum: 1,
        pageSize: 20,
        pageSizes: [10, 20, 50, 100, 200],
        total: 0,
        layout: 'total,sizes, prev, pager, next, jumper'
      },
      tabActive: 'batch',
      tableMaxHeight: WUYI.tableMaxHeight,
      pickerOptions: {
        disabledDate(time) {
          if (
            time.getTime() <
            new Date(new Date(WUYI.time.y - 1 + '/' + WUYI.time.m + '/' + WUYI.time.d + ' 00:00:00').getTime())
          )
            return true;
          if (time.getTime() > WUYI.time.timeend + 8.64e7 - 1000) return true;
          return false;
        }
      },
      pageSize: 20,
      currentPage: 1, //当前分页
      tableOptions: {
        batchId: '', // 批次号
        beginTime: WUYI.time.timestart,
        endTime: WUYI.time.timeend + 8.64e7 - 1000,
        batchStatus: null, // 批次状态
        orderNumber: '' // 运单号
      },
      cache: {},
      statusList: [
        { label: '待处理', value: 0 },
        { label: '审核中', value: 1 },
        { label: '已通过', value: 2 },
        { label: '已驳回', value: 3 },
        { label: '已关闭', value: 4 }
      ]
    };
  },
  activated() {
    this.tabActive = 'batch';
    if (!WUYI.checkDate(this.tableOptions.beginTime, this.tableOptions.endTime)) return;
    this.handleSearch();
  },
  methods: {
    tabChange(val) {
      if (this.tabActive == 'list') {
        this.$router.replace({
          path: '/exceptionOrderList'
        });
      } else if (this.tabActive == 'batch') {
        this.$router.replace({
          path: '/exceptionOrderBatch'
        });
      } else if (this.tabActive == 'deal') {
        this.$router.replace({
          path: '/dealOrderList'
        });
      }
    },
    handleToDetail(row) {
      this.$router.push({
        name: 'exceptionOrderBatchDetail',
        params: {
          key: row.batchId,
          type: 'edit'
        }
      });
    },
    showDetail(row) {
      this.$router.push({
        name: 'exceptionOrderBatchDetail',
        params: {
          key: row.batchId,
          type: 'detail'
        }
      });
    },
    changeStatus() {
      if (!this.tableOptions.batchStatus && this.tableOptions.batchStatus !== 0) {
        this.tableOptions.batchStatus = null;
      }
    }
  }
};
</script>
<style scoped>
.btn-disabled {
  color: #c0c4cc;
  cursor: default;
}
.font-orange {
  color: #ff9900;
}
</style>
<style>
.exception-order-batch .tab-Location {
  overflow: hidden;
  background: #fff;
  border-top: 0;
}
.exception-order-batch .el-tabs__header {
  height: 41px;
  border-bottom-color: #11ab19;
  margin: 15px;
}

.exception-order-batch .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  border: 1px solid #11ab19;
  height: 41px;
  border-bottom: none;
}
</style>
